@defer (when value()) {
  <app-servicio-form
    [access]="access()"
    [details]="true"
    [id]="id"
    [(value)]="value">
  </app-servicio-form>
}
